import React from "react"
import { Trans } from "@lingui/macro"
import { SectionContainer } from "@silversea-ssc/ui-components-react"
import clsx from "clsx"
import Tag from "../../Tag/Tag"
import { useCourtesyHold } from "../../../app-core/v3/_common/hooks/use-courtesy-hold"
import { VisibleMediaQueryBreakpoint } from "../../ResponsiveComponents"
import styles from "./CourtesyHoldAvailableBottomBar.module.scss"

export type CourtesyHoldAvailableBottomBarProps = {
    withDivider?: boolean
}

const CourtesyHoldAvailableBottomBar: React.FC<CourtesyHoldAvailableBottomBarProps> = ({ withDivider = true }) => {
    const courtesyHold = useCourtesyHold()

    if (courtesyHold.type === "expired") return null

    return (
        <div className={clsx(styles.root, { [styles.withDivider]: withDivider })}>
            <SectionContainer backgroundColor="titaniumDark" className={styles.content}>
                <VisibleMediaQueryBreakpoint type="between" from="xs" to="sm">
                    <div className={styles.availableLabel}>
                        <Trans>Free courtesy hold available</Trans>
                    </div>
                </VisibleMediaQueryBreakpoint>

                <VisibleMediaQueryBreakpoint type="up" from="sm">
                    <div className={styles.availableLabel}>
                        <Trans>Courtesy hold available</Trans>
                    </div>

                    <Tag className={styles.tag}>
                        <Trans>Free of charge - price blocked</Trans>
                    </Tag>
                </VisibleMediaQueryBreakpoint>
            </SectionContainer>
        </div>
    )
}

export default CourtesyHoldAvailableBottomBar
